var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24.9268 27.0476C22.6173 28.8952 19.6877 30 16.5 30C9.04416 30 3 23.9558 3 16.5C3 9.04416 9.04416 3 16.5 3C23.9558 3 30 9.04416 30 16.5C30 19.6874 28.8954 22.6168 27.0481 24.9262L32.5612 30.4394C33.147 31.0252 33.147 31.9749 32.5612 32.5607C31.9755 33.1465 31.0257 33.1465 30.4399 32.5607L24.9268 27.0476ZM6 16.5C6 10.701 10.701 6 16.5 6C22.299 6 27 10.701 27 16.5C27 19.3299 25.8805 21.8983 24.0602 23.7865C24.0098 23.8255 23.9612 23.8681 23.9149 23.9144C23.8686 23.9607 23.826 24.0093 23.787 24.0598C21.8987 25.8803 19.3301 27 16.5 27C10.701 27 6 22.299 6 16.5Z","fill":"#153E67"}));
}

Search.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = Search;

Search.default = Search;
